import(/* webpackMode: "eager", webpackExports: ["WeddingBudgetLanding"] */ "/app/src/components/Layout/weddingBudgetLanding.tsx");
